import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const plex = defineConnector({
  identifier: "plex",
  name: "Plex",
  tagLine: "Media server and streaming platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://plex\\.tv/.*|https://.*:32400/.*",
  auth: (app) =>
    headerAuth([{ name: "X-Plex-Token", value: app.secret.plexToken }]),
  steps: [
    {
      title: "Get your Plex token",
      items: [
        {
          kind: "markdown",
          content:
            "To find your Plex token, open any media item in the Plex web app, click **Get Info → View XML**, and copy the `X-Plex-Token` value from the URL.",
        },
        {
          kind: "input",
          label: "Plex token",
          required: true,
          target: { kind: "secrets", field: "plexToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://plex.tv/api/v2/user",
  },
});
